import { render } from "./MultIndex.vue?vue&type=template&id=42086e5a"
import script from "./MultIndex.vue?vue&type=script&lang=js"
export * from "./MultIndex.vue?vue&type=script&lang=js"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__